import { render } from "./DisplayLayoutGrid.vue?vue&type=template&id=472a34b1"
import script from "./DisplayLayoutGrid.vue?vue&type=script&lang=js"
export * from "./DisplayLayoutGrid.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__